<template>
    <div
        class="map-tab layout1 mg-scrollbar"
        :class="{
            'show-collapse': showCollapse,
            'show-business': !isMobile,
            detail: showDetail,
            expand: collapsed
        }"
        @click="replace && $emit('update:replace', false)"
        @mouseenter="replace && $emit('update:replace', false)"
    >
        <div class="tab-body" v-show="!showDetail">
            <Tab 
                class="business-tab"
                :modelValue="businessGroupActiveIndex"
                :options="businessTabs"
                @change="businessTabClick"
            />

            <slot></slot>

            <ul class="business-list mg-scrollbar">
                <li
                    v-for="item in businessList"
                    :key="item.id"
                    class="item"
                    :class="{
                        active:
                            itemActiveKey ===
                            'business-' +
                            item.latitude +
                            '-' +
                            item.longitude
                    }"
                    @mouseenter="
                        !isMobile && itemEnter('business', item)
                    "
                    @mouseleave="itemLeave('business')"
                    @click="isMobile && itemEnter('business', item)"
                >
                    <i :class="`iconfont ${businessTabs[businessGroupActiveIndex].icon}`"></i>
                    <div class="info">
                        <p class="name">{{ item.name }}</p>
                        <p class="address">{{ calcAddress(item) }}</p>
                        <p class="detail">
                            <span class="category">{{ item.categoryTertiary || item.categorySecondary || '' }}</span>
                            <span v-if="item.phone" class="phone">{{ $t('common:phone') }}: {{ item.phone }}</span>
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import mapTab from './map-tab.js';
import Tab from '@/components/Tab.vue';
import { calcAddress } from '@/components/map/js/markers';

export default {
    emits: ['update:replace', 'updateMarkerData'],
    mixins: [mapTab],
    methods: {
        calcAddress
    },
    components: {
        Tab
    }
};
</script>

<style lang="scss">
@import '@/theme/mixin.scss';
@import '@/theme/media.scss';
.map-tab.layout1 {
    .business-tab {
        margin-bottom: 20px;
    }
    .business-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 25px;
        max-height: 415px;
        overflow-y: auto;
        gap: 20px;
        padding-bottom: 20px;
        
        &::after {
            content: '';
            position: absolute;
            left: 0;
            bottom: 40px;
            width: 100%;
            height: 60px;
            background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, var(--g-bg-color) 73.68%);
        }

        .item {
            width: calc(50% - 30px);
            padding: 15px;
            display: flex;
            gap: 15px;
            &:hover,
            &.active {
                background-color: var(--g-primary-color_5);
            }

            & > .iconfont {
                flex-shrink: 0;
                width: 30px;
                height: 30px;
                font-size: 14px;
                border-radius: 50%;
                background-color: var(--g-primary-color);
                color: var(--g-bg-color);
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .info {
                display: flex;
                flex-direction: column;
                gap: 10px;
                line-height: 20px;
                font-size: 14px;
                color: var(--g-text-color);
            }
            .name {
                color: var(--g-primary-color);
                font-size: 24px;
                line-height: 30px;
            }
            .address {
                text-decoration: none;
            }
            .detail {
                font-size: 0;
                span + span {
                    &::before {
                        content: '';
                        display: inline-block;
                        width: 1px;
                        height: 12px;
                        background-color: var(--color-border);
                        margin: 0 10px;
                        vertical-align: middle;
                    }
                }
            }
            .category {
                font-size: 14px;
            }
            .phone {
                font-size: 14px;
            }
        }

        @include media-800 {
            max-height: 400px;
            margin-top: 20px;
            gap: 10px;
           .item {
                width: 100%;
                padding: 10px;

                & > .iconfont {
                    width: 24px;
                    height: 24px;
                    font-size: 12px;
                }
                .name {
                    font-size: 20px;
                    line-height: 24px;
                }
            }
        }
    }
}
</style>
